import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withTranslation, Trans } from 'gatsby-plugin-react-i18next'
import { graphql } from 'gatsby'
import StoreContext from 'src/context/StoreContext'
import { breakpoints, ContentContainer } from '../utils/styles/global-styles'

import SEO from '../components/seo'

import Cart from '../components/Cart'
import Analytics from '../utils/Analytics'
import ConsumerConfidence from '../components/ConsumerConfidence'

class CartPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
    }
    this.handleAddToCart = this.handleAddToCart.bind(this)
  }

  componentDidMount() {
    Analytics.track('Viewed Cart')
  }

  async handleAddToCart(variantId) {
    const { addToCart } = this.context
    const { submitting } = this.state
    if (!submitting) {
      this.setState({ submitting: true })
      try {
        Analytics.track('Added Frame Cross Sell Deal to Cart')
        const resp = await addToCart([{ variantId, quantity: 1 }])
        if (resp && resp.error) {
          alert(resp.error)
        }
      } catch (err) {
        console.error('Error adding to cart:', err)
      }
      this.setState({ submitting: false })
    }
  }

  render() {
    const {
      t,
      data: { cartOgImage },
    } = this.props

    return (
      <>
        <SEO
          title={t('Skylight Smart Devices | Shopping Cart')}
          path="/cart/"
          description={t('Bring home your Skylight Frame or Calendar today!')}
          imagePath={cartOgImage.childImageSharp.gatsbyImageData.images.fallback.src}
        />
        <Section>
          <Container>
            <Header>
              <Trans>Your Shopping Cart</Trans>
            </Header>
          </Container>
          <Cart handleAddToCart={this.handleAddToCart} />
          <ConsumerConfidence />
        </Section>
      </>
    )
  }
}

CartPage.propTypes = {
  t: PropTypes.func,
  data: PropTypes.shape({
    cartOgImage: PropTypes.object.isRequired,
  }).isRequired,
}
CartPage.contextType = StoreContext

export default withTranslation()(CartPage)

const Section = styled.div`
  background-color: ${(props) => props.theme.cream};
`
const Header = styled.h1`
  color: #444444;
  font-weight: 300;
  margin: 0px;
  @media (max-width: 768px) {
    font-size: 30px;
    text-align: center;
  }
`
const Container = styled(ContentContainer)`
  margin: 0px auto;
  padding: 20px 0px 0px;
  @media (max-width: ${breakpoints.s}px) {
    padding: 10px 0px 0px;
  }
`

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "cart"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    cartOgImage: file(relativePath: { eq: "meta-seo/cal-and-frame-1.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
      }
    }
  }
`
